export const defaultCenterGoogleMap = {
  lat: 20.473623708878552,
  lng: -103.44747586737101,
} // Tlajocomulco

export const mapContainerStyle = { height: '200px', width: '100%' }

export const optionsGoogleMap = { disableDefaultUI: true, zoomControl: true }

export const tlajomulcoPolygonCoords = [
  { lat: 20.491077, lng: -103.445458 },
  { lat: 20.489067, lng: -103.44623 },
  { lat: 20.488182, lng: -103.44623 },
  { lat: 20.488182, lng: -103.447603 },
  { lat: 20.484564, lng: -103.447947 },
  { lat: 20.482663, lng: -103.447823 },
  { lat: 20.483857, lng: -103.455713 },
  { lat: 20.483724, lng: -103.455527 },
  { lat: 20.483923, lng: -103.4558 },
  { lat: 20.483695, lng: -103.456376 },
  { lat: 20.485003, lng: -103.457105 },
  { lat: 20.482416, lng: -103.457772 },
  { lat: 20.482189, lng: -103.4585 },
  { lat: 20.478863, lng: -103.455466 },
  { lat: 20.478436, lng: -103.45583 },
  { lat: 20.479516, lng: -103.457287 },
  { lat: 20.478891, lng: -103.457894 },
  { lat: 20.477839, lng: -103.45668 },
  { lat: 20.47656, lng: -103.453099 },
  { lat: 20.473092, lng: -103.452917 },
  { lat: 20.47312, lng: -103.453433 },
  { lat: 20.471473, lng: -103.453192 },
  { lat: 20.468938, lng: -103.45431 },
  { lat: 20.467991, lng: -103.457161 },
  { lat: 20.466842, lng: -103.455934 },
  { lat: 20.467011, lng: -103.454382 },
  { lat: 20.466977, lng: -103.452903 },
  { lat: 20.466571, lng: -103.45164 },
  { lat: 20.464201, lng: -103.447439 },
  { lat: 20.462674, lng: -103.445352 },
  { lat: 20.460379, lng: -103.448439 },
  { lat: 20.459566, lng: -103.447495 },
  { lat: 20.453947, lng: -103.449409 },
  { lat: 20.453302, lng: -103.448593 },
  { lat: 20.45268, lng: -103.446143 },
  { lat: 20.451126, lng: -103.44673 },
  { lat: 20.449094, lng: -103.444433 },
  { lat: 20.448161, lng: -103.445097 },
  { lat: 20.446655, lng: -103.443464 },
  { lat: 20.44699, lng: -103.442035 },
  { lat: 20.444623, lng: -103.441754 },
  { lat: 20.444981, lng: -103.44007 },
  { lat: 20.442805, lng: -103.44007 },
  { lat: 20.442495, lng: -103.437237 },
  { lat: 20.443188, lng: -103.437263 },
  { lat: 20.443092, lng: -103.434277 },
  { lat: 20.441849, lng: -103.432823 },
  { lat: 20.446057, lng: -103.432006 },
  { lat: 20.445818, lng: -103.429403 },
  { lat: 20.443977, lng: -103.429786 },
  { lat: 20.443403, lng: -103.428663 },
  { lat: 20.447564, lng: -103.427974 },
  { lat: 20.44699, lng: -103.427285 },
  { lat: 20.450433, lng: -103.426214 },
  { lat: 20.4517, lng: -103.426852 },
  { lat: 20.451365, lng: -103.423228 },
  { lat: 20.453995, lng: -103.422539 },
  { lat: 20.454808, lng: -103.424759 },
  { lat: 20.459135, lng: -103.424019 },
  { lat: 20.463845, lng: -103.432134 },
  { lat: 20.46516, lng: -103.431802 },
  { lat: 20.465782, lng: -103.433614 },
  { lat: 20.468985, lng: -103.432772 },
  { lat: 20.467599, lng: -103.43785 },
  { lat: 20.470946, lng: -103.437543 },
  { lat: 20.470754, lng: -103.435604 },
  { lat: 20.472643, lng: -103.439253 },
  { lat: 20.478404, lng: -103.44058 },
  { lat: 20.481416, lng: -103.441703 },
  { lat: 20.48199, lng: -103.444331 },
  { lat: 20.484231, lng: -103.444025 },
  { lat: 20.485331, lng: -103.44331 },
  { lat: 20.487889, lng: -103.445479 },
  { lat: 20.491163, lng: -103.444484 },
  { lat: 20.491077, lng: -103.445458 },
]
